export const pharmacies = {
  farmaciaMeki: "Farmacia Meki",
  cruzverde: "Cruz Verde",
  farmaciaAhumada: "Ahumada",
  salcobrand: "Salcobrand",
  drsimi: "Dr. Simi",
};
